<div class="flex min-h-screen flex-col bg-ink text-parchment">
  <app-header />
  <main class="flex-1">
    <router-outlet />
  </main>
  <app-footer />
</div>
